export default function CookiePreferences() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Cookie Preferences</h1>
          <p>
            LEGITIMATELY uses cookies to enhance your browsing experience.
            Manage your preferences here.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Choose Your Preferences</h2>
              <form>
                <label>
                  <input type="checkbox" /> Functional Cookies (Required)
                </label>
                <br />
                <label>
                  <input type="checkbox" /> Analytics Cookies
                </label>
                <br />
                <label>
                  <input type="checkbox" /> Marketing Cookies
                </label>
                <br />
                <div className="speed-btn">
                  <button
                    className="view-more"
                    type="submit"
                    style={{
                      padding: "10px 15px",
                      marginTop: "10px",
                      marginBottom: "10px",
                      fontWeight: "500",
                      backgroundColor: "white",
                      border: "1px solid #d1d1d1",
                      color: "#232323",
                      borderRadius: "5px",
                    }}
                  >
                    Save Preferences
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
